export const SET_MEDICAL_CASES = 'SET_MEDICAL_CASES';
export const ADD_MEDICAL_CASE = 'ADD_MEDICAL_CASE';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_FILTER_PATIENT_NAME = 'SET_FILTER_PATIENT_NAME';
export const SET_FILTER_USERNAME = 'SET_FILTER_USERNAME';
export const SET_FILTER_DATE_INTERVAL = 'SET_FILTER_DATE_INTERVAL';
export const SET_IS_DIRTY = 'SET_IS_DIRTY';
